<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="640">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-2" small text v-bind="attrs" v-on="on">
          Change Password
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Change Password
        </v-card-title>

        <v-card-text>
          <v-form ref="frmRegister">
            <v-text-field required v-model="user.password" placeholder="Password" type="password" :rules="passwordRules" :counter="20"></v-text-field>
            <v-text-field required v-model="user.newPassword" placeholder="New Password" :rules="newPasswordRules" type="password" :counter="20"></v-text-field>
            <v-text-field required v-model="user.passwordConfirm" placeholder="Confirm Password" :rules="passwordConfirmRules" type="password" :counter="20">
            </v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="changePassword">
            Submit
          </v-btn>
          <v-btn color="error" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        user: {
          password: '',
          newPassword: '',
          passwordConfirm: ''
        },
        // Form Verification
        valid: false,
        passwordRules: [
          v => !!v || 'Password is required',
        ],
        newPasswordRules: [
          v => !!v || 'New Password is required',
        ],
        passwordConfirmRules: [v => v == this.user.newPassword || 'Passwords must match.'],
        dialog: false,
      }
    },
    computed: {
      ...mapState('auth', ['auth']),
    },
    methods: {
      changePassword() {
        if(this.$refs.frmRegister.validate()) {
          this.$axios.put(`/users/${this.auth.profile.user.id}`, this.user).then(res => {
            console.log(res.data)
            if (res.data.msg){
              this.$toastr.e(res.data.msg)
              return false
            }
            this.$toastr.s("Updated password successfully")
            this.resetForm()
          }).catch(err => {
            this.$toastr.e(err.message)
            console.log(err)
          })
        }
      },
      resetForm(){
        this.user = {
          password: '',
          newPassword: '',
          passwordConfirm: ''
        }
        this.dialog = false
      }
    }
  }
</script>